import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getReferences } from '../lib/api';

const defaultReferences = [
  { name: 'Terra Pizza' },
  { name: 'Boston Drink' },
  { name: 'Fast Coffee' },
  { name: "Dipsos's Döner" },
  { name: 'Çikolata Evim' },
  { name: 'Ivy Çikolata' },
  { name: 'Mama Durağı' },
  { name: 'Napoleon Salata' },
  { name: 'Bir Dilim Pizza' },
  { name: 'Erkan Usta' },
];

// Render colored text parts
const ColoredText = ({ parts, fallbackName }) => {
  if (!parts || parts.length === 0) {
    return <span>{fallbackName}</span>;
  }
  
  try {
    const parsed = typeof parts === 'string' ? JSON.parse(parts) : parts;
    return (
      <span>
        {parsed.map((part, index) => (
          <span key={index} style={{ color: part.color || 'inherit' }}>
            {part.text}
          </span>
        ))}
      </span>
    );
  } catch (e) {
    return <span>{fallbackName}</span>;
  }
};

export const ReferencesSection = ({ audience }) => {
  const { t } = useTranslation();
  const [references, setReferences] = useState(defaultReferences);

  useEffect(() => {
    const fetchReferences = async () => {
      try {
        const response = await getReferences(audience);
        if (response.data && response.data.length > 0) {
          setReferences(response.data.filter(r => r.is_active));
        }
      } catch (err) {
        // Use defaults
      }
    };
    fetchReferences();
  }, [audience]);

  return (
    <section id="references" className="relative py-24 overflow-hidden" data-testid="references-section">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-muted/20" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-card/50 border border-border text-sm font-medium text-foreground mb-4">
            {t('references')}
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-foreground">
            {t('references_trusted')}
          </h2>
          <p className="mt-4 text-foreground/80 text-lg">
            {t('references_leading')}
          </p>
        </motion.div>

        <div className="relative">
          {/* Gradient masks */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-muted/20 to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-muted/20 to-transparent z-10" />

          <Marquee speed={25} pauseOnHover gradient={false} direction="right">
            {references.map((ref, index) => (
              <div
                key={index}
                className="mx-3 px-6 py-3 rounded-lg border border-border"
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
              >
                {ref.logo_url ? (
                  <img
                    src={ref.logo_url}
                    alt={ref.name}
                    className="h-10 w-auto object-contain"
                  />
                ) : (
                  <span className="font-medium whitespace-nowrap">
                    <ColoredText parts={ref.name_parts} fallbackName={ref.name} />
                  </span>
                )}
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};
